export default __webpack_public_path__ + "static/media/linkedin.834498bb.svg";